import React from 'react';

const AddonSection = ({ title, items, selectedAddons, toggleAddon }) => (
  <section className="booking-card">
    <h4 className="booking-section-title">{title}</h4>
    <div className="addon-grid">
      {items.map((item) => {
        const active = selectedAddons.includes(item.label);
        return (
          <button
            key={item.label}
            type="button"
            className={`addon-card${active ? ' active' : ''}`}
            onClick={() => toggleAddon(item.label)}
          >
            {item.img && <img src={item.img} alt={item.label} />}
            <span className="addon-name">{item.label}</span>
            <div className="addon-price">
              <span>{item.price}</span>
              {item.oldPrice && <span className="old-price">{item.oldPrice}</span>}
            </div>
            {active && <span className="addon-check bi bi-check-lg" />}
          </button>
        );
      })}
    </div>
  </section>
);

const StepAddons = ({ extras, gifts, services, selectedAddons, toggleAddon }) => {
  return (
    <>
      <AddonSection
        title="Extra Decoration (optional)"
        items={extras}
        selectedAddons={selectedAddons}
        toggleAddon={toggleAddon}
      />
      <AddonSection
        title="Choose Gifts (optional)"
        items={gifts}
        selectedAddons={selectedAddons}
        toggleAddon={toggleAddon}
      />
      <AddonSection
        title="Special services (optional)"
        items={services}
        selectedAddons={selectedAddons}
        toggleAddon={toggleAddon}
      />
    </>
  );
};

export default StepAddons;
